import PropTypes from "prop-types";

function ReservationTabs({ options, value, onChange }) {
    return (
        <div className="-mx-4 min-w-0 overflow-x-auto overflow-y-hidden overscroll-x-contain touch-pan-x sm:-mx-5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <div className="flex w-max flex-nowrap gap-2 px-4 sm:px-5">
                {options.map(({ label, value: tabValue }) => {
                    const isActive = tabValue === value;

                    return (
                        <button
                            key={tabValue}
                            type="button"
                            onClick={() => onChange(tabValue)}
                            className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                                isActive
                                    ? "bg-[#5D5DF6] text-white shadow-sm"
                                    : "bg-gray-100 text-[#2F2F46] hover:bg-gray-200"
                            }`}>
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

ReservationTabs.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ReservationTabs;
